export default __webpack_public_path__ + "images/92c31ce274979ddecd2d996bbfb7336d-people-illustration.png";